export const dummy = {
    "event": "Abbalanche",
    "procData": [
        {
            "tableNo": 1,
            "diet": "No",
            "bookingName": "Karen Barnes",
            "people": 11,
            "type": "ds",
            "eatCount": 11
        },
        {
            "tableNo": 2,
            "diet": "",
            "bookingName": "Jacqueline Estraube",
            "people": 11,
            "type": "ds",
            "eatCount": 11
        },
        {
            "tableNo": 3,
            "diet": "1 vegetarian",
            "bookingName": "Valerie Wood",
            "people": 10,
            "type": "ds",
            "eatCount": 10
        },
        {
            "tableNo": 4,
            "diet": "",
            "bookingName": "Kylie Taylor",
            "people": 7,
            "type": "ds",
            "eatCount": 7
        },
        {
            "tableNo": 5,
            "diet": "",
            "bookingName": "Donna O'Neill",
            "people": 8,
            "type": "ds",
            "eatCount": 8
        },
        {
            "tableNo": 6,
            "diet": "",
            "bookingName": "Jane Stalker",
            "people": 6,
            "type": "ds",
            "eatCount": 6
        },
        {
            "tableNo": 7,
            "diet": "vegetarian",
            "bookingName": "Catherine Gallagher",
            "people": 10,
            "type": "ds",
            "eatCount": 10
        },
        {
            "tableNo": 8,
            "diet": "No Fish",
            "bookingName": "Donna Simcock",
            "people": 11,
            "type": "ds",
            "eatCount": 11
        },
        {
            "tableNo": 9,
            "diet": "no requirements needed",
            "bookingName": "Amanda Hay",
            "people": 11,
            "type": "ds",
            "eatCount": 11
        },
        {
            "tableNo": 10,
            "diet": "only for show .",
            "bookingName": "Elizabeth Barnes",
            "people": 10,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 11,
            "diet": "",
            "bookingName": "Julie Maiden",
            "people": 8,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 12,
            "diet": "",
            "bookingName": "Sue Johnston",
            "people": 8,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 13,
            "diet": "1 guest requires soft food",
            "bookingName": "SUSANNE CHARLESWORTH",
            "people": 7,
            "type": "ds",
            "eatCount": 7
        },
        {
            "tableNo": 14,
            "diet": "",
            "bookingName": "colin dawson",
            "people": 6,
            "type": "mixed",
            "eatCount": 2
        },
        {
            "tableNo": 15,
            "diet": "no;no",
            "bookingName": "Julie Maiden",
            "people": 6,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 16,
            "diet": "",
            "bookingName": "Jacinta Wallace",
            "people": 6,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 17,
            "diet": "",
            "bookingName": "Liz Hartigan",
            "people": 4,
            "type": "ds",
            "eatCount": 4
        },
        {
            "tableNo": 18,
            "diet": "no shellfish x 1",
            "bookingName": "Rose Ferris",
            "people": 4,
            "type": "ds",
            "eatCount": 4
        },
        {
            "tableNo": 19,
            "diet": "",
            "bookingName": "Melinda Munro",
            "people": 6,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 20,
            "diet": "no;no",
            "bookingName": "Sherree Rattenbury",
            "people": 7,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 21,
            "diet": "non",
            "bookingName": "Zara Masters",
            "people": 12,
            "type": "s",
            "eatCount": 0
        },
        {
            "tableNo": 22,
            "diet": "6 pork allergy",
            "bookingName": "Allison Hurley",
            "people": 12,
            "type": "mixed",
            "eatCount": 7
        }
    ],
    "showMetrics": {
        "total": 181,
        "ds": 109,
        "s": 72
    }
}